import { VIEW } from "../../utils/constant";
const polygone = "/assets/svg/polygone.svg";
const BgDark = "/assets/svg/bg-dark.svg";

export const getBackground = (mode: string) =>
  mode === VIEW.LIGHT
    ? `linear-gradient(rgba(0,229,255,.8), rgba(100,122,228,0.8)), url(${polygone}) center center  / cover no-repeat`
    : `url(${BgDark}) top / cover`;
